import format from 'format-util';

export function formatArgs(...args) {
  const firstArg = args[0];

  // Keep a pure object as is
  if (args.length === 1 && typeof firstArg === 'object' && !(firstArg instanceof Array)) {
    return firstArg;
  }

  const usesStringFormatting = firstArg.indexOf('%') !== -1;
  if (usesStringFormatting) {
    const [message, ...formatData] = args;

    return format(message, ...formatData);
  }

  const strings = args.map(arg => typeof arg === 'string' ? arg : JSON.stringify(arg));

  return strings.join(' ');
}



// WEBPACK FOOTER //
// ./src/utils/logglyHelper.js